//# sourceMappingURL=timer.mjs.map
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import { start_timer as do_start, stop_timer as do_stop } from "./timer_ffi.mjs";

export function restart(timer, interval, timer_msg, tick_msg) {
  return $effect.from(
    (dispatch) => {
      $option.map(timer, do_stop);
      let id = do_start(interval, () => { return dispatch(tick_msg); });
      return dispatch(timer_msg(id));
    },
  );
}
